import { useQuery } from '@tanstack/react-query';
import { getLicenseStatus } from '../services/license.api';

export const licenseKeys = {
  status: ['license-status'] as const
};

export function useLicenseStatus() {
  return useQuery({
    queryKey: licenseKeys.status,
    queryFn: getLicenseStatus,
    staleTime: 60_000,
    retry: false
  });
}
